import { Box, Card, Chip, IconButton, Stack, Typography } from "@mui/material";
import { History, Responses } from "../../types";
import { FC, useState } from "react";
import HistoryDialog from "./HistoryDialog";
import { grey } from "@mui/material/colors";
import { displayDateTime } from "../../helpers/datetimes";
import * as apiClient from "../../api";
import { FileDownload } from "@mui/icons-material";

interface HistoryCardProps {
  patientId: string;
  history: History;
  editPatientHistory: (historyId: number, responses: Responses) => void;
  deletePatientHistory: (historyId: number) => void;
}

const HistoryCard: FC<HistoryCardProps> = ({
  patientId,
  history,
  editPatientHistory,
  deletePatientHistory,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDownload = async (historyId: number) => {
    const res = await apiClient.downloadHistoryPdf(patientId, historyId);
    const { pdfLink } = res.data;
    window.open(pdfLink, "_blank");
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          padding: "0.5rem",
          cursor: "pointer",
          ":hover": { backgroundColor: grey[100] },
        }}
        onClick={handleOpen}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box>
            <Typography variant="body1">
              {displayDateTime(history.createdAt)}
            </Typography>

            {history.possibleDiagnoses.length === 0 ? (
              <Typography variant="caption">No diagnoses detected</Typography>
            ) : (
              <Stack direction="row" spacing={1} marginTop="0.5rem">
                {history.possibleDiagnoses.map((possibleDiagnosis) => (
                  <Chip
                    key={possibleDiagnosis.calculatorId}
                    component="a"
                    href={`/calculators/${possibleDiagnosis.calculatorId}`}
                    clickable
                    size="small"
                    color="primary"
                    label={possibleDiagnosis.classification}
                    onClick={(e) => e.stopPropagation()}
                  />
                ))}
              </Stack>
            )}
          </Box>

          <Box>
            <IconButton
              size="large"
              onClick={(e) => {
                e.stopPropagation();
                handleDownload(history.historyId);
              }}
            >
              <FileDownload />
            </IconButton>
          </Box>
        </Stack>
      </Card>

      <HistoryDialog
        providedHistory={history}
        editPatientHistory={editPatientHistory}
        deletePatientHistory={deletePatientHistory}
        handleClose={handleClose}
        open={open}
        variant="edit"
      />
    </>
  );
};

export default HistoryCard;
